<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Εκτύπωση ωραρίων προσωπικού</h4>
          <!-- <p class="card-title-desc">Διαχείρηση και επεξεργασία προσωπικού</p> -->
          <div v-if="errorMsg">
            <b-alert show dismissible variant="danger">{{ errorMsg }}</b-alert>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-md-2">
                <div class="mb-3">
                  <label class="mt-3">Από</label>
                  <b-form-input
                    id="example-input"
                    v-model="startDate"
                    type="date"
                    placeholder="DD-MM-YYYY"
                    format="DD-MM-YYYY"
                    autocomplete="off"
                  ></b-form-input>
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-3">
                  <label class="mt-3">Μέχρι</label>
                  <b-form-input
                    id="example-input"
                    v-model="endDate"
                    type="date"
                    placeholder="DD-MM-YYYY"
                    format="DD-MM-YYYY"
                    autocomplete="off"
                  ></b-form-input>
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-md-8">
                    <div class="mb-1">
                      <label>Τμήμα</label>
                      <multiselect
                        v-model="departmentValue"
                        :options="departmentNames"
                        track-by="id"
                        label="name"
                        placeholder="Επιλέξτε Τμήμα"
                        selectLabel="Eπιλογή Τμήματος"
                        selectedLabel="Επιλέχθηκε"
                        deselectLabel="Αποεπιλογή"
                      ></multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-md-4">
                    <div class="mb-2">
                      <label class="mt-1">Ονομα Χρήστη</label>
                      <multiselect
                        v-model="personOptionValue"
                        :options="peopleOptions"
                        track-by="id"
                        label="name"
                        placeholder="Επιλέξτε Χρήστη"
                        selectLabel="Eπιλογή Χρηση"
                        selectedLabel="Επιλέχθηκε"
                        deselectLabel="Αποεπιλογή"
                      ></multiselect>
                      <!-- <input
                        v-model="personID"
                        type="text"
                        class="form-control"
                        placeholder="Όνομα Χρήστη"
                      /> -->
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="mb-3">
                      <label class="mt-1">Υπογραφές</label>
                      <multiselect
                        v-model="signatureSelected"
                        :options="signatureOptions"
                        track-by="id"
                        label="name"
                        placeholder="Επιλέξτε Υπογραφή"
                        selectLabel="Eπιλογή Υπογραφής"
                        selectedLabel="Επιλέχθηκε"
                        deselectLabel="Αποεπιλογή"
                      ></multiselect>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-12" style="margin-top:150px;">
            <div class="row">
              <div class="col-md-2">
                <div class="mt-2">
                  <button class="btn btn-primary" @click.prevent="submitPrint">
                    Προεπισκόπηση
                  </button>
                </div>
              </div>
              <!-- <div class="col-md-2">
                <div class="mt-2">
                  <button
                    class="btn btn-primary"
                    ref="download"
                    id="download"
                    @click.prevent="getSchedule"
                  >
                    Κατεβάστε
                  </button>
                </div>
              </div> -->
              <b-modal
                id="modal-center"
                size="sm"
                title="Παρακαλώ περιμένετε..."
                title-class="font-18"
                hide-footer
              >
                <b-spinner
                  v-show="spinnerShow"
                  class="m-2"
                  variant="primary"
                  role="status"
                ></b-spinner>
                <p>Γινεται επεξεργασία των στοιχείων</p>
              </b-modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import { mapState, mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import session from "../../../../api/session";

export default {
  page: {
    title: "Εκτύπωση ωραρίων",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      title: "Εκτυπωση ωραριων",
      items: [
        {
          text: "Αρχική",
          to: { name: "home" },
        },
        {
          text: "Εκτύπωση ωραρίων",
          active: true,
        },
      ],
      startDate: "",
      endDate: "",
      departmentValue: "",
      // personID: "",
      errorMsg: "",
      signaturesOptions: [],
      signatureSelected: "",
      spinnerShow: false,
      downloadable: "",
      personOptionValue: "",
      peopleFilter: {
        department: "",
      },
    };
  },

  computed: {
    ...mapGetters("auth", ["is_staff", "is_superuser"]),
    ...mapState("utils", [
      "peopleOptionFields",
      "departmentOptions",
      "signatures",
    ]),
    departmentNames() {
      return this.departmentOptions.map((e) => {
        return { id: e.id, name: e.department_parent_name };
      });
    },

    signatureOptions() {
      return this.signatures.map((e) => {
        return { id: e.id, name: e.name };
      });
    },
    peopleOptions() {
      if (this.departmentValue && this.departmentValue.id) {
        return this.peopleOptionFields
          .filter((e) => {
            return e.department.includes(this.departmentValue.id);
          })
          .map((e) => {
            return { id: e.id, name: e.person_full_name };
          });
      } else {
        return this.peopleOptionFields.map((e) => {
          return { id: e.id, name: e.person_full_name };
        });
      }
    },
  },
  methods: {
    preFillDepartmentValue() {
      if (!(this.is_staff || this.is_superuser)) {
        this.departmentValue = this.departmentOptions.map(
          (e) => `${e.parent_name}/${e.name}`
        )[0];
      }
    },

    async submitPrint() {
      const data = {
        start_date: this.startDate
          ? this.startDate
          : new Date().toISOString().split("T")[0],
        end_date: this.endDate
          ? this.endDate
          : this.startDate || new Date().toISOString().split("T")[0],
        department:
          this.departmentValue && this.departmentValue.id
            ? this.departmentValue.id
            : "",
        person:
          this.personOptionValue && this.personOptionValue.id
            ? this.personOptionValue.id
            : "",
        signature:
          this.signatureSelected && this.signatureSelected.name
            ? this.signatureSelected.name
            : "",
      };

      const params = new URLSearchParams(data).toString();
      this.spinnerShow = true;
      this.$bvModal.show("modal-center");

      await session
        .get(`api/workers-schedule/?${params}`, { responseType: "blob" })
        .then((resp) => {
          this.spinnerShow = false;
          this.$bvModal.hide("modal-center");
          if (resp.data.type === "application/json") {
            this.errorMsg = "Δεν βρέθηκαν αποτελέσματα...";
            return;
          }

          const blobData = resp.data;
          const blob = new Blob([blobData], { type: "application/pdf" });

          const objectUrl = URL.createObjectURL(blob);

          if (this.downloadable) {
            const link = document.createElement("a");
            link.href = objectUrl;
            link.download = `parousies ${new Date().toLocaleString()}`;
            link.click();
            URL.revokeObjectURL(link.href);
          }

          window.open(objectUrl, "_blank");
          this.errorMsg = "";
          URL.revokeObjectURL(objectUrl);
        })
        .catch((e) => {
          console.log(e.response.data);
          this.errorMsg =
            "Κάτι πήγε στραβά, παρακαλώ επικοινωνήστε με τους διαχειριστές";
          setTimeout(() => {
            this.errorMsg = "";
          }, 3000);
        });
    },
  },
};
</script>
